import React from 'react'
import { useNavigate } from 'react-router-dom';
import { Box, Flex, Image, Heading, IconButton, Input, HStack, Menu, Portal } from '@chakra-ui/react'
import { InputGroup } from '../ui/input-group'
import { useState } from 'react'
import { FaCircleUser } from "react-icons/fa6";
import { IoMdSearch } from "react-icons/io";



const NavBar = () => {
    const [currentPage, setCurrentPage] = useState("Home");
    const [openMenu, setOpenMenu] = useState(false);
    const navigate = useNavigate();

    const handleOpenMenu = () => {
        setOpenMenu(!openMenu);
    }

    const navToDash = () => {
        navigate('/editAccount');
    }


  return (
    <Box as={'nav'} w={'5/6'} h={'1/12'} pos={'fixed'} style={{left: 'calc(100vw * 1/6)'}} bg={'red'}>
        <Flex justifyContent={'space-between'} p={6} bg={'gray.600'} align={'center'} color={'white'} bgColor={'#B1BFFF'} h={'full'}>
            <Heading fontSize={'5xl'} fontFamily={'Esteban'} paddingLeft={12} color={'#465362'}>
                {currentPage}
            </Heading>
            <HStack gap={8}>
                <InputGroup startElement={<IoMdSearch style={{width: "80%", height: "80%"}} />} >
                   <Input placeholder={"Search"} bg={"gray.100"} rounded={"xl"} 
                    p={4} color={"black"} fontSize={20} w={'full'} ps={12}></Input>
                </InputGroup>
                <Menu.Root  positioning={{ placement: "bottom" }}>
                    <Menu.Trigger asChild>
                        <IconButton rounded={'xl'} bg={'transparent'} size={'md'} color={'#ED254E'} >
                            <FaCircleUser style={{width: "100%", height: "100%"}} />
                        </IconButton>
                    </Menu.Trigger>
                    <Portal>
                        <Menu.Positioner>
                            <Menu.Content>
                                <Menu.Item value="account" onClick={navToDash}>Account</Menu.Item>
                                <Menu.Item value="settings">Settings</Menu.Item>
                                <Menu.Item value="children">Managed Accounts</Menu.Item>
                                <Menu.Item value="logout">Logout</Menu.Item>
                            </Menu.Content>
                        </Menu.Positioner>
                    </Portal>
                </Menu.Root>
            </HStack>
        </Flex>
    </Box>
  )
}

export default NavBar